import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const EMBED = "https://www.google.com/maps?q=Bliss+Dine+Restaurant+%26+Banquet,+Chandlodiya,+Ahmedabad&output=embed";

export const LocationSection = () => (
  <motion.section
    className="sec snap-sec"
    data-testid="location-section"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.2 }}
    transition={{ duration: 0.8 }}
  >
    <div className="sec-title f-corm">Location</div>
    <div className="loc-venue f-corm" data-testid="location-venue">Bliss Dine Restaurant &amp; Banquet</div>
    <div className="loc-addr f-corm">Opp. Shreepati Apartments, 42, Savitri Nagar,<br />Chandlodiya, Ahmedabad - 382481</div>
    <div className="map-frame">
      <iframe
        title="Venue map"
        src={EMBED}
        width="100%"
        height="260"
        style={{ border: 0, display: "block" }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        data-testid="map-iframe"
      />
    </div>
    <a
      className="gold-btn f-corm"
      href="https://maps.app.goo.gl/RaRAbEXEADprovpW7"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="map-open-btn"
    >
      <MapPin size={15} /> OPEN IN GOOGLE MAPS
    </a>
  </motion.section>
);
